import React, {useEffect, useRef, useState} from 'react';
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import exec2 from './Ресурс 19@3x.png';
import upvLogo from './upv-logo.svg';
import grad_model from './model_graduate.png'
import teacher1 from './emba-tormosov.jpg';
import teacher2 from './emba-ibadildin.jpg';
import teacher3 from './emba-nassanbekova.jpg';
import teacher4 from './emba-amirova.jpg';
import teacher5 from './emba-raskaliyev.jpg';
import styles from './new_mba.module.css';
import cl from "../Home/components/Banner/Banner.module.css";
import {
    CalendarOutlined,
    DownOutlined,
    FileTextOutlined,
    FormOutlined,
    GlobalOutlined,
    TrophyOutlined,
} from "@ant-design/icons";
import IntlMessage, {IntlMessageText} from "../../components/IntlMessage/IntlMessage";
import {Fade} from "react-awesome-reveal";
import {Flex, Form, Input, message, Select} from "antd";
import FormItem from "antd/es/form/FormItem";
import InputMask from "react-input-mask";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import BlockLoading from "../../components/LoadingComponents/BlockLoading";
import GreyButton from "../../components/UI/Buttons/GreyButton";
import ApplicationService from "../../services/ApplicationService";
import {EmailValidator} from "../../utils/EmailValidator";
import {LocalName} from "../../utils/LocalName";
import {clrs} from "../../constants/colors";

const EMBAPage = () => {
    // Форма заявки — копия блока со страницы Foundation (FoundationPage.jsx:682-747)
    const [form] = Form.useForm();
    const name = Form.useWatch('name', form);
    const email = Form.useWatch('email', form);
    const telNumber = Form.useWatch('telNumber', form);
    const categoryId = Form.useWatch('categoryId', form);

    const {t} = useTranslation();

    const categoriesListFromRedux = useSelector(state => state.categoriesList);

    const [categories, setCategories] = useState([]);
    const [categoriesListManager, setCategoriesListManager] = useState([]);

    const [loading, setLoading] = useState(false);

    // Кнопка в шапке ведёт к блоку заявки внизу страницы.
    const applyFormRef = useRef(null);

    function scrollToApplyForm() {
        applyFormRef.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    }

    function handleSubmit() {
        form.validateFields()
            .then(async () => {
                message.loading(<IntlMessage id={'loading'}/>, 0);
                setLoading(true);
                await ApplicationService.saveApplication(
                    name,
                    email,
                    telNumber.endsWith('_') ? telNumber.slice(0, -1) : telNumber,
                    categoryId)
                    .then(() => {
                        message.destroy();
                        if (categoriesListManager.includes(categoryId)) {
                            message.success(<IntlMessage id={'successApplicationSendManager'}/>, 5);
                        } else {
                            message.success(<IntlMessage id={'successApplicationSend'}/>, 5);
                        }
                        form.resetFields();
                        setLoading(false);
                    })
                    .catch((reason) => {
                        message.destroy();
                        if (reason?.response.data === "application already exists") {
                            message.error(<IntlMessage id={'applicationIsAlreadyExists'}/>, 5);
                        } else {
                            message.error(<IntlMessage id={'error'}/>, 5);
                        }
                        setLoading(false);
                    })
            })
            .catch(() => {
                console.log("Validation error!")
            })
    }

    useEffect(() => {
        setCategories(
            categoriesListFromRedux.categories.map(category => {
                return {
                    value: category.id, label: category?.nameEng !== 'Listeners'
                        ? LocalName.getName(category)
                        : <IntlMessage id="listeners"/>
                }
            })
        )
        setCategoriesListManager(
            categoriesListFromRedux.categories
                .filter(category => category.formType !== "FOUNDATION")
                .map(category => category.id)
        );

        // Страница посвящена одной программе, поэтому в заявке EMBA выбрана сразу.
        // Категория заводится в InitService (nameEng = "EMBA") и появляется на проде только
        // после рестарта бэкенда; пока её нет — поле просто остаётся пустым, как раньше.
        // Уже выбранное пользователем значение не перетираем.
        const embaCategory = categoriesListFromRedux.categories
            .find(category => category?.nameEng === 'EMBA');
        if (embaCategory && !form.getFieldValue('categoryId')) {
            form.setFieldValue('categoryId', embaCategory.id);
        }
    }, [categoriesListFromRedux.categories]);

    const outcomes = [
        {titleKey: "emba-pm-outcome-1-title", descKey: "emba-pm-outcome-1-desc"},
        {titleKey: "emba-pm-outcome-2-title", descKey: "emba-pm-outcome-2-desc"},
        {titleKey: "emba-pm-outcome-3-title", descKey: "emba-pm-outcome-3-desc"},
        {titleKey: "emba-pm-outcome-4-title", descKey: "emba-pm-outcome-4-desc"},
        {titleKey: "emba-pm-outcome-5-title", descKey: "emba-pm-outcome-5-desc"},
        {titleKey: "emba-pm-outcome-6-title", descKey: "emba-pm-outcome-6-desc"},
        {titleKey: "emba-pm-outcome-7-title", descKey: "emba-pm-outcome-7-desc"},
        {titleKey: "emba-pm-outcome-8-title", descKey: "emba-pm-outcome-8-desc"},
        {titleKey: "emba-pm-outcome-9-title", descKey: "emba-pm-outcome-9-desc"},
    ];

    const teachers = [
        {name: "emba-pm-tr-1n", desc: "emba-pm-tr-1d", img: teacher1},
        {name: "emba-pm-tr-2n", desc: "emba-pm-tr-2d", img: teacher2},
        {name: "emba-pm-tr-3n", desc: "emba-pm-tr-3d", img: teacher3},
        {name: "emba-pm-tr-4n", desc: "emba-pm-tr-4d", img: teacher4},
        {name: "emba-pm-tr-5n", desc: "emba-pm-tr-5d", img: teacher5},
    ];

    const mandatoryDisciplines = [
        "emba-pm-md-1", "emba-pm-md-2", "emba-pm-md-3", "emba-pm-md-4",
        "emba-pm-md-5", "emba-pm-md-6", "emba-pm-md-7", "emba-pm-md-8",
        "emba-pm-md-9", "emba-pm-md-10", "emba-pm-md-11", "emba-pm-md-12",
        "emba-pm-md-13", "emba-pm-md-14", "emba-pm-md-15",
    ];

    const electiveA = [
        "emba-pm-ch-3-1", "emba-pm-ch-3-2",
    ];

    const electiveB = [
        "emba-pm-ch-4-1", "emba-pm-ch-4-2",
    ];

    return (
        <div className={styles.page}>
            <Header/>

            {/* Hero */}
            <section className={styles.hero}>
                <div className={styles.heroInner}>
                    <Fade triggerOnce cascade damping={0.15} direction="down">
                        <div className={styles.heroText}>
                            <h1 className={styles.heroTitle}>
                                <IntlMessage id="emba-pm"/>
                            </h1>
                            <p className={styles.heroSubtitle}>
                                <IntlMessage id="emba-pm-h1"/>
                            </p>
                            <p className={styles.heroPartner}>
                                <IntlMessage id="emba-pm-h2"/>
                            </p>
                        </div>
                    </Fade>
                    <button type="button" className={styles.heroCta} onClick={scrollToApplyForm}>
                        <IntlMessage id={'bannerText2'}/> <DownOutlined/>
                    </button>
                </div>
            </section>

            {/* Facts strip */}
            <div className={styles.factsStrip}>
                <div className={styles.factsInner}>
                    <Fade triggerOnce cascade damping={0.1} direction="up">
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <CalendarOutlined/> <IntlMessage id="trainDuration"/>
                            </p>
                            <p className={styles.factValue}>12 <IntlMessage id="months"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <FileTextOutlined/> <IntlMessage id="emba-pm-credits"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="emba-pm-credits-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <FormOutlined/> <IntlMessage id="trainFormat"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="emba-pm-format-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <GlobalOutlined/> <IntlMessage id="trainLanguage"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="emba-pm-lang-val"/></p>
                        </div>
                        <div className={styles.factItem}>
                            <p className={styles.factLabel}>
                                <TrophyOutlined/> <IntlMessage id="emba-pm-degree"/>
                            </p>
                            <p className={styles.factValue}><IntlMessage id="emba-pm-degree-val"/></p>
                        </div>
                    </Fade>
                </div>
            </div>

            {/* Program Goal */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="emba-pm-goal-title"/>
                    </h2>
                </Fade>
                <Fade triggerOnce direction="left">
                    <p className={styles.descText}>
                        <IntlMessage id="emba-pm-goal-desc"/>
                    </p>
                    <p className={styles.descText} style={{fontWeight: 600, color: '#333'}}>
                        <IntlMessage id="emba-pm-goal-directions"/>
                    </p>
                    <ul className={styles.goalsList}>
                        <li><IntlMessage id="emba-pm-goal-1"/></li>
                        <li><IntlMessage id="emba-pm-goal-2"/></li>
                        <li><IntlMessage id="emba-pm-goal-3"/></li>
                        <li><IntlMessage id="emba-pm-goal-4"/></li>
                        <li><IntlMessage id="emba-pm-goal-5"/></li>
                        <li><IntlMessage id="emba-pm-goal-6"/></li>
                        <li><IntlMessage id="emba-pm-goal-7"/></li>
                        <li><IntlMessage id="emba-pm-goal-8"/></li>
                    </ul>
                </Fade>
            </div>

            {/* Program Structure */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="programStructure"/>
                        </h2>
                    </Fade>

                    <div className={`${styles.structureGrid} ${styles.structureGridTop}`}>
                        {/* Mandatory disciplines */}
                        <Fade triggerOnce direction="left">
                            <div className={styles.structureBlock}>
                                <div className={styles.structureBlockHeader}>
                                    <IntlMessage id="mandatoryDisp"/>
                                </div>
                                <div className={styles.structureBlockBody}>
                                    <ul>
                                        {mandatoryDisciplines.map((key) => (
                                            <li key={key}><IntlMessage id={key}/></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </Fade>

                        {/* Elective modules */}
                        <Fade triggerOnce direction="right">
                            <div className={styles.structureBlock}>
                                <div className={styles.structureBlockHeaderAlt}>
                                    <IntlMessage id="chooseModules"/>
                                </div>
                                <div className={styles.structureBlockBody}>
                                    <div>
                                        <p className={styles.electiveSubTitle}>
                                            <IntlMessage id="emba-pm-ch-1"/>
                                        </p>
                                        <ul>
                                            {electiveA.map((key) => (
                                                <li key={key}><IntlMessage id={key}/></li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className={styles.electiveSubBlock}>
                                        <p className={styles.electiveSubTitle}>
                                            <IntlMessage id="emba-pm-ch-2"/>
                                        </p>
                                        <ul>
                                            {electiveB.map((key) => (
                                                <li key={key}><IntlMessage id={key}/></li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </div>

            {/* Learning Outcomes */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="emba-pm-outcomes-title"/>
                    </h2>
                </Fade>
                <div className={styles.outcomesGrid}>
                    {outcomes.map((outcome, index) => (
                        <Fade triggerOnce direction="up" delay={index * 40} key={index}>
                            <div className={styles.outcomeCard}>
                                <h4><IntlMessage id={outcome.titleKey}/></h4>
                                <p><IntlMessage id={outcome.descKey}/></p>
                            </div>
                        </Fade>
                    ))}
                </div>
            </div>

            {/* Teachers */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="ourTeachers"/>
                        </h2>
                    </Fade>
                    <div className={styles.teachersGrid}>
                        {teachers.map((teacher, index) => (
                            <Fade triggerOnce direction="up" delay={index * 60} key={index}>
                                <div className={styles.teacherCard}>
                                    <img src={teacher.img} alt=""/>
                                    <h3><IntlMessage id={teacher.name}/></h3>
                                    <p><IntlMessage id={teacher.desc}/></p>
                                </div>
                            </Fade>
                        ))}
                    </div>
                </div>
            </div>

            {/* Graduate Diplomas */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="graduateDiplomas"/>
                    </h2>
                </Fade>
                <div className={styles.diplomasGrid}>
                    <Fade triggerOnce direction="up">
                        <div className={styles.diplomaCard}>
                            <img src={exec2} alt=""/>
                            <p><IntlMessage id="emba-pm-dip-1"/></p>
                        </div>
                    </Fade>
                    <Fade triggerOnce direction="up" delay={100}>
                        <div className={styles.diplomaCard}>
                            <img className={styles.diplomaLogo} src={upvLogo} alt=""/>
                            <p><IntlMessage id="emba-pm-dip-2"/></p>
                        </div>
                    </Fade>
                </div>
            </div>

            {/* Graduate student model */}
            <div className={styles.sectionAlt}>
                <div className={styles.sectionAltInner}>
                    <Fade triggerOnce direction="down">
                        <h2 className={styles.sectionTitle}>
                            <IntlMessage id="graduateStudentModel"/>
                        </h2>
                    </Fade>
                    <Fade triggerOnce direction="up">
                        <img style={{
                            maxWidth: "100%", borderRadius: "8px",
                        }} src={grad_model} alt=""/>
                    </Fade>
                </div>
            </div>

            {/* Required docs */}
            <div className={styles.section}>
                <Fade triggerOnce direction="down">
                    <h2 className={styles.sectionTitle}>
                        <IntlMessage id="requiredDocuments"/>
                    </h2>
                </Fade>
                <div className={`${styles.docsGrid} ${styles.docsGridSingle}`}>
                    <Fade triggerOnce direction="left">
                        <ul className={styles.goalsList}>
                            <li><IntlMessage id="mbaFinDoc1"/></li>
                            <li><IntlMessage id="mbaFinDoc2"/></li>
                            <li><IntlMessage id="mbaFinDoc3"/></li>
                            <li><IntlMessage id="mbaFinDoc4"/></li>
                            <li><IntlMessage id="mbaFinDoc5"/></li>
                            <li><IntlMessage id="mbaFinDoc6"/></li>
                            <li><IntlMessage id="mbaFinDoc7"/></li>
                            <li><IntlMessage id="mbaFinDoc8"/></li>
                            <li><IntlMessage id="mbaFinDoc9"/></li>
                        </ul>
                    </Fade>
                </div>
            </div>

            {/* Application form — как внизу страницы Foundation */}
            <div className={`${styles.section} ${styles.applyAnchor}`} ref={applyFormRef}>
                <Flex style={{width: "100%", position: "relative"}} gap={20} align={"center"} justify={"center"}>
                    <Fade triggerOnce={true} cascade style={{width: '100%'}}>
                        <Form form={form} onSubmit={handleSubmit}>
                            <BlockLoading isLoading={loading}/>
                            <div>
                                <p className={cl.bannerFormText}><IntlMessage id={'bannerText2'}/></p>
                                <p className={cl.bannerFormText}><IntlMessage id={'bannerText3'}/></p>
                                <br/>
                            </div>

                            <FormItem rules={[{
                                required: true,
                                message: <IntlMessage id={'bannerFormNameError'}/>,
                            },
                            ]} name="name">
                                <Input placeholder={IntlMessageText.getText({id: 'name'})}/>
                            </FormItem>
                            <FormItem rules={[{
                                required: true,
                                message: <IntlMessage id={'bannerFormEmailError'}/>,
                            },
                                () => ({
                                    validator(_, value) {
                                        if (EmailValidator.isValid(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(t('emailRules')));
                                    },
                                }),
                            ]} name="email">
                                <Input placeholder={IntlMessageText.getText({id: 'email'})}/>
                            </FormItem>
                            <FormItem rules={[{
                                required: true,
                                message: <IntlMessage id={'bannerFormTelError'}/>,
                            },
                            ]} name="telNumber">
                                <InputMask
                                    mask="+9 (999) 999-9999"
                                    placeholder={IntlMessageText.getText({id: 'telNumber'})}
                                >
                                    {(inputProps) => <Input {...inputProps} />}
                                </InputMask>
                            </FormItem>
                            <FormItem rules={[{
                                required: true,
                                message: <IntlMessage id={'requiredField'}/>,
                            },
                            ]} style={{width: "100%", padding: 0}} name="categoryId">
                                <Select
                                    options={categories}
                                    placeholder={<IntlMessage id={'categoryCourse'}/>}
                                />
                            </FormItem>
                            <FormItem>
                                <Flex style={{width: "100%"}} align={"center"} justify={"center"}>
                                    <GreyButton onClick={handleSubmit} backgroundColor={clrs.blackerBlue}
                                                fontColor={clrs.white}>
                                        <IntlMessage id={'send'}/>
                                    </GreyButton>
                                </Flex>
                            </FormItem>
                        </Form>
                    </Fade>
                </Flex>
            </div>

            <Footer/>
        </div>
    );
};

export default EMBAPage;
